// extracted by mini-css-extract-plugin
module.exports = {"button-error":"button-error-tyoybdGYw1","buttonError":"button-error-tyoybdGYw1","customize-footer":"customize-footer-E1yegrkcoF","customizeFooter":"customize-footer-E1yegrkcoF"};